/* file description */
import React, { useRef, useState } from 'react';
import {
  Button,
  InfiniteScroll,
  List,
  Popover,
  Popup,
  Modal,
  Ellipsis,
} from 'antd-mobile';
import styles from '../../index.module.less';
import { SPField } from '@/components/SPForm';

interface ItemViewProps {
  value: any;
  columns: any[];
}

export const ItemView: React.FC<ItemViewProps> = ({ value = {}, columns }) => {
  return (
    <List>
      {columns.map((option: any, index: number) => {
        const { render, dataIndex, title, ...others } = option || {};
        return (
          <List.Item key={dataIndex}>
            <div className={styles['item-x-wrap']} >
              <div className={styles['item-x-label-wrap']}>{title} :</div>
              <div className={styles['item-content-text-wrap']}>
                <SPField
                  from="form"
                  key={index}
                  rowIndex={index}
                  name={[option.dataIndex]}
                  render={option.render}
                  valueType={option.valueType}
                  formItemProps={option.formItemProps}
                  fieldProps={option.fieldProps}
                  style={{ marginBottom: 0 }}
                  formValue={value}
                  mode="read"
                />
              </div>
            </div>
          </List.Item>
        );
      })}
    </List>
  );
};
